﻿import { GetJson } from '../global.js';

$page.load = function () {
    appSlider.init($page.data.id, $page.data.url);
};

let appSlider = {
    options: {
        el: '#slick-slider',
        data: {
        },
        mounted: function () {
        }
    },
    start: () => {
        $(".slider").slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            centerMode: false,
            variableWidth: true,
            arrows: false,
        });
    },
    init: (id, thumbnailUrl) => {

        GetJson('/api/bizphotos/' + id).then(res => {

            if (res.length > 0) {
                appSlider.options.data.items = res;
                let app = new Vue(appSlider.options);
                appSlider.start();
            }
            else {
                let img = document.createElement('img');
                if (thumbnailUrl.length == 0)
                    thumbnailUrl = 'default.jpg';

                if (thumbnailUrl.indexOf('/api/') == 0)
                    img.setAttribute("src", thumbnailUrl);
                else
                    img.setAttribute("src", "/api/u/firm_img/" + thumbnailUrl);

                let div = document.createElement('div');
                div.classList.add('slide-content');
                div.append(img);
                let c = document.getElementById('slick-slider');
                c.innerHTML = '';
                c.append(div);
            }
        });
    }
};